var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bgr",
    width: 32,
    height: 32,
    fill: "none",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M-465,54a2,2,0,0,1-2-2V41a2,2,0,0,1,2-2h16a2,2,0,0,1,2,2V52a2,2,0,0,1-2,2Zm0-2h16V42.295l-7.365,6.053a1,1,0,0,1-.635.228,1,1,0,0,1-.634-.228L-465,42.294Zm8-5.719L-450.575,41h-12.849Z",
    transform: "translate(473 -30)",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.563fdee3d84563156cb28e8a28208a51.svg";
export { ForwardRef as ReactComponent };